
/**
 *
 * @class Status
 *
 * @brief a basic trait for classes that need a readiness status and error state support.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2019
 *
 */
export class Status {

  /** @var _ready the current object readiness for use */
  private     _ready: boolean;

  /** @var _lastError the last error message that was set */
  private _lastError: string;

  constructor() {
    this._lastError = '';
    this._ready     = false;
  }
  /** @brief set the new current error message */
  public setError(msg: string): boolean {

    this._lastError = msg;

    return true;
  }

  /** @brief fetch the current error message */
  public getError(): string {

    return this._lastError;
  }

  /** @brief test to see if this object is ready. */
  public isReady(): boolean {

    return this._ready;
  }

  /** @brief force this object ot be ready. */
  public makeReady(): boolean {

    this._ready = true;

    return true;
  }

  /** @brief force this object to not be ready. */
  public unReady(): boolean {

    this._ready = false;

    return true;
  }

}
